import { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import DrawerTablet from "../components/DrawerTablet";
import PortalDrawer from "../components/PortalDrawer";
import CardContainer from "../components/CardContainer";
import Secondary from "../components/Secondary";
import Footer from "../components/Footer";

const About = () => {
  const navigate = useNavigate();
  const [isDrawerTabletOpen, setDrawerTabletOpen] = useState(false);
  const [isDrawerTablet1Open, setDrawerTablet1Open] = useState(false);

  const onAddButtonContainerClick = useCallback(() => {
    navigate("/sign-up");
  }, [navigate]);

  const openDrawerTablet = useCallback(() => {
    setDrawerTabletOpen(true);
  }, []);

  const closeDrawerTablet = useCallback(() => {
    setDrawerTabletOpen(false);
  }, []);

  const onAddContainerClick = useCallback(() => {
    navigate("/sign-up");
  }, [navigate]);

  const openDrawerTablet1 = useCallback(() => {
    setDrawerTablet1Open(true);
  }, []);

  const closeDrawerTablet1 = useCallback(() => {
    setDrawerTablet1Open(false);
  }, []);

  return (
    <>
      <div className="relative w-full overflow-hidden flex flex-col items-center justify-start gap-[64px] bg-[url(/public/about@3x.png)] bg-cover bg-no-repeat bg-[top] text-left text-28xl text-dark font-footnote">
        <div className="self-stretch bg-light flex flex-row p-8 items-center justify-between md:hidden">
          <img className="relative w-[160.68px] h-10" alt="" src="/union.svg" />
          <div className="flex flex-row items-center justify-start gap-[16px]">
            <img
              className="relative w-[21.5px] h-[21.5px] hidden"
              alt=""
              src="/search13.svg"
            />
            <div
              className="rounded-19xl bg-gold flex flex-row items-center justify-start cursor-pointer hover:bg-goldenrod-100"
              onClick={onAddButtonContainerClick}
            >
              <img className="relative w-10 h-10" alt="" src="/add6.svg" />
            </div>
            <div
              className="flex flex-row items-center justify-start cursor-pointer"
              onClick={openDrawerTablet}
            >
              <div className="rounded-19xl bg-sky-blue-100 flex flex-row items-center justify-start hover:bg-aliceblue-200">
                <img
                  className="relative w-[62px] h-[62px]"
                  alt=""
                  src="/add4.svg"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="self-stretch bg-light hidden flex-row p-8 items-center justify-between md:flex md:self-stretch md:w-auto">
          <img className="relative w-[160.68px] h-10" alt="" src="/union.svg" />
          <div className="flex flex-row items-center justify-start gap-[16px]">
            <img
              className="relative w-[21.5px] h-[21.5px] hidden"
              alt=""
              src="/search14.svg"
            />
            <div
              className="rounded-19xl bg-gold flex flex-row items-center justify-start cursor-pointer hover:bg-goldenrod-100"
              onClick={onAddContainerClick}
            >
              <img className="relative w-10 h-10" alt="" src="/add6.svg" />
            </div>
            <div className="flex flex-row items-center justify-start">
              <div
                className="rounded-19xl bg-sky-blue-100 flex flex-row items-center justify-start cursor-pointer hover:bg-goldenrod-100 md:hover:bg-aliceblue-200"
                onClick={openDrawerTablet1}
              >
                <img
                  className="relative w-[62px] h-[62px]"
                  alt=""
                  src="/add4.svg"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="rounded-3xl overflow-hidden flex flex-col items-start justify-start">
          <div className="self-stretch bg-lavender h-[445px] flex flex-row py-2.5 px-8 box-border items-center justify-center sm:items-center sm:justify-center sm:pl-8 sm:box-border">
            <div className="flex-1 relative leading-[40px] sm:flex-1 sm:max-w-[360px]">
              <span className="tracking-[-0.02em]">
                <b>Prairie</b>
              </span>
              <span className="text-8xl font-h2-accent">
                <span>
                  <span className="tracking-[-0.02em]">{` `}</span>is a curation
                  of locations, products, and events for
                </span>
                <span className="tracking-[-0.02em]">
                  <span className="font-footnote">{` `}</span>
                  <b className="font-footnote">autism caregivers</b>
                  <span className="font-footnote">{`. `}</span>
                </span>
              </span>
            </div>
          </div>
          <div className="bg-light flex flex-col py-20 px-8 items-center justify-start gap-[64px] text-center">
            <b className="relative tracking-[-0.02em] leading-[40px] inline-block w-[450px]">
              Founders
            </b>
            <div className="self-stretch flex flex-row items-start justify-center gap-[64px] sm:flex-col">
              <CardContainer
                avatarImageUrl="/rectangle-203@2x.png"
                personName="Paul Hsueh"
                roleTitle="CEO / CTO"
              />
              <CardContainer
                avatarImageUrl="/rectangle-21@2x.png"
                personName="Charles Walsh"
                roleTitle={`Design & Product`}
              />
            </div>
          </div>
        </div>
        <Secondary buttonText="Home" secondaryPosition="unset" />
        <Footer
          logo="/union.svg"
          propJustifyContent="space-between"
          propGap="unset"
        />
      </div>
      {isDrawerTabletOpen && (
        <PortalDrawer
          overlayColor="rgba(229, 219, 255, 0.7)"
          placement="Right"
          onOutsideClick={closeDrawerTablet}
        >
          <DrawerTablet onClose={closeDrawerTablet} />
        </PortalDrawer>
      )}
      {isDrawerTablet1Open && (
        <PortalDrawer
          overlayColor="rgba(229, 219, 255, 0.7)"
          placement="Right"
          onOutsideClick={closeDrawerTablet1}
        >
          <DrawerTablet onClose={closeDrawerTablet1} />
        </PortalDrawer>
      )}
    </>
  );
};

export default About;
